import { BreadcrumbGroup } from '@cloudscape-design/components';
import { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DemoContext } from '../components/demo-context';
import { Layout } from '../components/layout';
import DemoDetails from '../components/DemoDetails';

export default function DemoDetailsPage() {
    const { path } = useParams();
    const navigate = useNavigate();
    const demos = useContext(DemoContext);
    const demo = demos.find((demo) => demo.path === path);
    console.log('DemoDetailsPage', demo);

    const breadcrumbs = (
        <BreadcrumbGroup
            onClick={({ detail }) => navigate(detail.href)}
            items={[
                { text: "Demos", href: "/" },
                { text: demo?.name || "Demo Details", href: `/details/${path}` }
            ]}
        />
    );

    // Page views are now handled by RouteTracker in App.tsx
    if(!demo) {
        return (
            <Layout breadcrumbs={breadcrumbs}>
                <p>Loading...</p>
            </Layout>
        );
    }
    return (
        <Layout breadcrumbs={breadcrumbs}>
            <DemoDetails {...demo} />
        </Layout>
    );
}
